
import * as React from 'react';
import { Dispatch, Action } from 'redux';
import { connect } from 'react-redux';
import * as H from 'history';
import { v4 as uuidv4 } from 'uuid';
import  * as moment from 'moment';
import { Typography, Paper, Button, Grid } from '@material-ui/core';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import CloudUpload from '@material-ui/icons/CloudUpload';
import RotateRight from '@material-ui/icons/RotateRight';
import RotateLeft from '@material-ui/icons/RotateLeft';
import Rotate90 from '@material-ui/icons/Rotate90DegreesCcw';

import { IAppState, kansatsuKirokuOperations } from '../redux/modules';
import { CloseBackButton } from './parts/CloseBackButton';
import SelectPicture from './SelectPicture';
import { SiteInfoListState } from '../redux/modules/siteInfoList';
import { inferenceResultOperations } from '../redux/modules';
import { SiteInfo } from '../models/SiteInfo';
import { InferenceResultState } from '../redux/modules/inference';
import { InferenceResultView } from './parts/InferenceResultView';
import { KansatsuKirokuState } from '../redux/modules/kansatsuKiroku';
import { KansatsuKiroku } from '../models/KansatsuKiroku';
import KansatsuKirokuEdit from './parts/KansatsuKirokuEdit';

// @ts-ignore
const createObjectURL = (window.URL || window.webkitURL).createObjectURL || window.createObjectURL;

const styles = {
  contentBase: {
    padding: '20px',
    marginBottom: '20px'
  }
};

interface OwnProps {
  match: any; // withRouterにより設定される
  sites: SiteInfoListState;
  clear: () => void;
  history: H.History;
  execute: ({ koujiBangou, inferenceId, imageStr, contentType }
      :{ koujiBangou: string, inferenceId: string, imageStr:string, contentType:string }) => any;
  reset: () => any;
  getRecord: ({ koujiBangou, key, completeHandler }
      :{ koujiBangou: string, key: string, completeHandler: () => any }) => any;
  postRecord: (record: KansatsuKiroku, originalImageStr: string, originalImageContentType: string, completeHandler: () => any) => any
  inferenceResult: InferenceResultState;
  kansatsuKiroku: KansatsuKirokuState;
}

interface OwnState {
  // 選択したファイルの内容
  sourceImage: string;
  // プレビューが設定されているか
  isSetPreview: boolean;
  // 工事現場の情報
  site: SiteInfo;
  // 推論ID
  inferenceId: string;
};

class InferencePage extends React.Component<OwnProps, OwnState>{
  private cropperElement;
  private previewCanvasElement;
  private kansatsuKirokuEditElement;
  // private croppedImgElement: HTMLImageElement | null;
  constructor(props: OwnProps) {
    super(props);
    this.state = {
      sourceImage: '',
      isSetPreview: false,
      site: new SiteInfo(),
      inferenceId: ''
    };
  }

  /**
   * 以下のルールで推論IDを生成する
   * 工事番号-YYYYMMDDHHmmss-UUIDv4
   */
  generateInferenceId():string {
    return `${
      this.props.match.params.koujibangou
    }-${
      moment().format('YYYYMMDDHHmmss')
    }-${
      uuidv4()
    }`;
  }

  /**
   * 画像ファイルが選択されたらStateを更新する。
   * stateがCropperのsrcに設定されているのでCropperに画像が表示される
   */
  pictureFileSelected(src: string) {
    // ファイルが選択されたときだけ画像を設定する.
    if (src) {
      this.setState({ sourceImage: src });
    }
  }
  componentDidMount() {
    // このページの工事番号
    const koujiBangou = this.props.match.params.koujibangou;
    // このページの工事情報
    const siteInfo = this.props.sites.items.find((item) => (item.koujiBangou === koujiBangou));
    // 工事情報が不正な場合はリストに戻る
    if (!siteInfo) {
      this.props.history.replace('/sitelist');
      return ;
    }
    this.setState({ site: siteInfo });
  }
  componentWillUnmount() {
    this.props.reset();
  }
  /**
   * cropされた画像を縮小してプレビュー表示する
   */
  previewImage() {
    // // プレビューを表示するcanvas
    const previewCanvasContext = this.previewCanvasElement.getContext('2d');

    // 切り抜かれたcanvas
    const croppedCanvas = this.cropperElement.cropper.getCroppedCanvas();
    // プレビュー領域を切り抜き領域のサイズに合わせる
    this.previewCanvasElement.width = this.state.site.cropImageWidth;
    this.previewCanvasElement.height = this.state.site.cropImageHeight;
    previewCanvasContext.drawImage(
      croppedCanvas, // 描画内容
      0, 0, croppedCanvas.width, croppedCanvas.height, // 元canvasから取得する描画領域
      0, 0, this.previewCanvasElement.width, this.previewCanvasElement.height
    )
    this.setState({ isSetPreview: true });
  }

  // 画像を回転させる
  rotate(dig: number) {
    this.cropperElement.cropper.rotate(dig);
    console.log('cropper image rotate :', `${this.cropperElement.getImageData().rotate}`);
    console.log('cropper naturalWidth x naturalHeight:', `${this.cropperElement.getCanvasData().naturalWidth} x ${this.cropperElement.getCanvasData().naturalHeight} = ${this.cropperElement.getCanvasData().naturalWidth * this.cropperElement.getCanvasData().naturalHeight}`);
  }

  /**
   * 診断を実行する
   */
  execute() {
    // base64で取得する
    // 'Data:image/jpeg;base64,iVBORw....'の形なので','以前を除去する
    const dataUrl = this.previewCanvasElement.toDataURL('image/jpeg');
    const imageStr = dataUrl.replace(/^.*,/,'');
    const match = dataUrl.match(/data:(.*?);/i);
    // 正規表現でContentTypeを取り出し
    const contentType = (match && match.length >= 2) ? match[1] : '';
    // 推論IDを生成する
    const inferenceId = this.generateInferenceId()
    this.setState({ inferenceId });
    const koujiBangou = this.props.match.params.koujibangou;
    this.props.execute({ koujiBangou, inferenceId, imageStr, contentType });
  }

  /**
   * データを登録する
   */
  register() {
    // 登録するレコード
    const record = { ...this.props.kansatsuKiroku.item };
    record.koujiBangou = this.props.match.params.koujibangou;
    // 新規作成ならキーを生成する
    record.key = uuidv4();;
    const kansatsuKirokuEditData = this.kansatsuKirokuEditElement.get();
    record.kansatsuDate = kansatsuKirokuEditData.kansatsuDate;
    record.sokutenNumber = kansatsuKirokuEditData.sokutenNumber;
    record.danmenNumber = kansatsuKirokuEditData.danmenNumber;
    record.kyori = kansatsuKirokuEditData.kyori;
    record.kansatsuDateMemo = kansatsuKirokuEditData.kansatsuDateMemo;
    record.sokutenNumberMemo = kansatsuKirokuEditData.sokutenNumberMemo;
    record.danmenNumberMemo = kansatsuKirokuEditData.danmenNumberMemo;
    record.kyoriMemo = kansatsuKirokuEditData.kyoriMemo;
    record.inferenceResultJsonStr = JSON.stringify(this.props.inferenceResult.results);
    record.inferenceAdditionalResultJsonStr = JSON.stringify(this.props.inferenceResult.additionalResult);
    record.inferenceId = this.state.inferenceId;
    record.croppedImageBucket = this.props.inferenceResult.croppedImage.bucket;
    record.croppedImageKey = this.props.inferenceResult.croppedImage.key;
    record.freeInputs = kansatsuKirokuEditData.freeInputs;
    record.freeInputsJsonStr = JSON.stringify(kansatsuKirokuEditData.freeInputs);

    // 新規登録時は作成日時と更新日時は同一
    record.createdAt = moment().format();
    record.lastModifiedAt = record.createdAt;

    // base64で取得する
    // 'Data:image/jpeg;base64,iVBORw....'の形なので','以前を除去する
    const originalImageStr = this.state.sourceImage.replace(/^.*,/,'');
    const match = this.state.sourceImage.match(/data:(.*?);/i);
    // 正規表現でContentTypeを取り出し
    const originalImageContentType = (match && match.length >= 2) ? match[1] : '';

    this.props.postRecord(
      record,
      originalImageStr,
      originalImageContentType,
      () => {
        // 登録完了したら編集画面に移動する
        this.props.history.replace(`/kansatsukiroku/${record.koujiBangou}/${record.key}`);
      }
    );
  }

  render() {
    const site = this.state.site || new SiteInfo();
    return (
    <div>
      <Paper style={{ padding: '10px' }}>
        <Typography variant="h4" style={{ marginBottom: '10px' }}>
          {site.koujiBangou} : {site.name}
        </Typography>
        <Typography variant="h6">① 写真を撮影または選択</Typography>
        <Paper
          style={styles.contentBase}
        >
          <SelectPicture
            color="secondary"
            onFileSelected={(str) => this.pictureFileSelected(str)}
          />
        </Paper>
        <Typography variant="h6">② 画像位置・サイズを調整</Typography>
        <Paper
          style={styles.contentBase}
        >
          <Typography variant="body2">
            青色の枠に切羽画像を合わせてください。
          </Typography>
          <Cropper
            ref={(r) => (this.cropperElement = r)}
            src={this.state.sourceImage}
            style={{
              width: '100%',
              height: 400
            }}
            dragMode="move"
            // Cropper.js options
            aspectRatio={this.state.site.cropImageWidth / this.state.site.cropImageHeight} // 湯の上の画像の実際値
            guides={false}
          />
          <Typography variant="body2">診断画像サイズ　幅: {this.state.site.cropImageWidth}px, 高さ: {this.state.site.cropImageHeight}px</Typography>
          <Grid container spacing={16} style={{ marginTop: '10px' }} >
            <Grid item xs={4}>
              <Button
                disabled={!this.state.sourceImage}
                variant="contained"
                onClick={() => this.rotate(1)}
                fullWidth
              >
                <RotateRight />
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                disabled={!this.state.sourceImage}
                variant="contained"
                onClick={() => this.rotate(-1)}
                fullWidth
              >
                <RotateLeft />
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                disabled={!this.state.sourceImage}
                variant="contained"
                onClick={() => this.rotate(-30)}
                fullWidth
              >
                <Rotate90 /> 30°
              </Button>
            </Grid>
          </Grid>

          <Button
            color="secondary"
            disabled={!this.state.sourceImage}
            variant="contained"
            fullWidth
            style={{ marginTop: '10px' }}
            onClick={() => this.previewImage()}
          >
            画像位置を決定
          </Button>
        </Paper>

        <Typography variant="h6">③ 診断を実行する</Typography>
        <Paper
          style={styles.contentBase}
        >
          <canvas
            style={{
              width: this.state.site.cropImageWidth,
              height: this.state.site.cropImageHeight
            }}
            ref={(r) => {
              if (r) {
                this.previewCanvasElement = r;
              }
            }}
          />
          <Button
            variant="contained"
            color="secondary"
            disabled={!this.state.isSetPreview}
            fullWidth
            style={{
              marginTop: '10px'
            }}
            onClick={() => {
              this.execute();
              // console.log('this.cropperElement', this.cropperElement);
              // // @ts-ignore
              // console.log('this.cropperElement.cropper', this.cropperElement.cropper);
              // // @ts-ignore
              // console.log('this.cropperElement.cropper.getCroppedCanvas()', this.cropperElement.cropper.getCroppedCanvas());
              // console.log('this.cropperElement.cropper.getCroppedCanvas().toDataURL()', this.cropperElement.cropper.getCroppedCanvas().toDataURL());
              // // // @ts-ignore
              // console.log('this.cropperElement.cropper.getCroppedCanvas().toDataURL()', this.cropperElement.cropper.getCroppedCanvas().toDataURL());
              // if (this.croppedImgElement) {
              // // @ts-ignore
              //   this.croppedImgElement.src = this.cropperElement.cropper.getCroppedCanvas().toDataURL();
              // }
            }}
          >
            <CloudUpload style={{ marginRight: '5px'}}/>
            送信して診断開始
          </Button>
        </Paper>
        <Typography variant="h6">④ 診断結果</Typography>
        <Paper
          style={styles.contentBase}
        >
          <div
            style={{
              display: this.props.inferenceResult.loaded ? 'block': 'none'
            }}
          >
            <InferenceResultView
              result={this.props.inferenceResult.results}
              additionalResult={this.props.inferenceResult.additionalResult}
            />
          </div>
        </Paper>
        <Typography variant="h6">⑤ 観察記録</Typography>
        <Paper
          style={styles.contentBase}
        >
          <div
            style={{
              display: this.props.inferenceResult.loaded ? 'block': 'none'
            }}
          >
            <KansatsuKirokuEdit
              disabled={false}
              data={this.props.kansatsuKiroku.item}
              ref={(r) => {
                if (r) {
                  this.kansatsuKirokuEditElement = r;
                }
              }}
            />
          </div>
          <Button
            variant="contained"
            color="secondary"
            disabled={!this.props.inferenceResult.loaded}
            fullWidth
            onClick={() => this.register()}
          >
            <CloudUpload style={{ marginRight: '5px'}}/>
            診断結果と観察記録を保存
          </Button>
        </Paper>
        <CloseBackButton history={this.props.history} />
      </Paper>
    </div>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch<Action<any>>) {
  return {
    execute: ({ koujiBangou, inferenceId, imageStr, contentType }) => {
      inferenceResultOperations.execute({ koujiBangou, inferenceId, imageStr, contentType })(dispatch);
    },
    getRecord: ({ koujiBangou, key, completeHandler }) => {
      kansatsuKirokuOperations.get({ koujiBangou, key })(dispatch)
        .then(() => completeHandler());
    },
    postRecord: (record, originalImageStr, originalImageContentType, completeHandler) => {
      kansatsuKirokuOperations.post(record, originalImageStr, originalImageContentType)(dispatch)
        .then(() => completeHandler());
    },
    reset: () => {
      inferenceResultOperations.reset()(dispatch);
      kansatsuKirokuOperations.resetRecord()(dispatch);
    }
  };
}

function mapStateToProps(appState: IAppState) {
  return {
    user: appState.user,
    sites: appState.siteInfoList,
    inferenceResult: appState.inferenceResult,
    kansatsuKiroku: appState.kansatsuKiroku
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InferencePage);



// WEBPACK FOOTER //
// ./src/components/InferencePage.tsx